<template>
  <div class="lg:mb-12 md:mb-12 bg-cbedf2">
    <div
      class="grid lg:grid-cols-5 md:grid-cols-3 grid-cols-1 gap-4 lg:px-12 md:px-12 py-8 lg:my-0 md:my-0 my-8"
    >
      <div
        v-for="(item, index) in impactNo"
        :key="index"
        class="cust-fsize35 p-4 text-center"
      >
        <div class="flex items-center justify-center">
          <countTo
            :startVal="item.start"
            :endVal="item.end"
            :duration="3000"
            :style="{ color: item.color }"
          ></countTo>
          <feather-icon
            icon="PlusIcon"
            class="cursor-pointer font-bold"
            :style="{ color: item.color }"
          />
        </div>

        <p class="abtus-impact-desc pb-1 pt-2 text-center">{{ item.desc }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";
export default {
  components: {
    countTo,
  },
  data() {
    return {
      impactNo: [
        {
          start: 0,
          end: 33814,
          desc: "Our Community Size",
          color: "#00ADC0",
          linecolor: "#CCEFF2",
        },
        {
          start: 0,
          end: 911,
          desc: "Lives of Caregiver Touched",
          color: "#8383FF",
          linecolor: "#EEE2FF",
        },
        {
          start: 0,
          end: 186,
          desc: "Benevolent Donors",
          color: "#00ADC0",
          linecolor: "#CCEFF2",
        },
        {
          start: 0,
          end: 1880,
          desc: "Volunteers, Ambassadors, Interns",
          color: "#8383FF",
          linecolor: "#EEE2FF",
        },
        {
          start: 0,
          end: 12,
          desc: "Corporate Clients",
          color: "#00ADC0",
          linecolor: "#CCEFF2",
        },
      ],
    };
  },
};
</script>
